// Korean (ko-KR) — default locale / source of truth.
// Every key added here must also have a corresponding entry in ja.ts and zh.ts.
// Naming convention: <domain>.<sub>.<key> in snake_case.

const ko = {
  // ── Navigation ─────────────────────────────────────────────────────────────
  'nav.home_label': '홈 대시보드로 이동',
  'nav.expand': '메뉴 펼치기',
  'nav.collapse': '메뉴 접기',
  'nav.api_connected': '서버 연결됨',

  'nav.group.business': 'Business',
  'nav.group.manufacturing': 'Manufacturing',
  'nav.group.field': 'Field',
  'nav.group.admin': 'Admin',

  'nav.item.customer_master': '고객사 마스터',
  // S1 Phase 8 — 사이드바 BUSINESS 그룹 '고객사 서류' 탭.
  'nav.item.customer_documents': '고객사 서류',
  // 2026-10-23 — 구글 시트 '인바운드 문의 현황'의 '데모-계약 전환' 탭과 양방향.
  'nav.item.inbound': '인바운드 현황(자동)',
  'nav.item.demo_conversion': '데모-계약 전환',
  'nav.item.inquiry': '도입 문의 현황(수기)',
  // 아래 세 라벨('계약' · '영업 파이프라인' · '매장')은 **사이드바에서 쓰지 않는다**
  // (26-08-05 확인). 화면(/business/contracts, /business/deals, /business/stores)은
  // router 에 살아 있어 주소를 직접 치거나 화면 안 링크로 도달한다.
  //
  // §Phase 3(26-05-26) 오너 결정: 영업 그룹은 '고객사 마스터' 단일 진입점.
  // 라벨을 지우지 않고 남겨 두는 이유는 화면 안 제목·링크 문구에 쓰이기 때문이다.
  //
  // ⚠ 두 번 어긋난 자리다. ① 옛 주석이 세 항목을 "사이드바에 추가"했다고 적었지만
  //   사실이 아니었다(라벨만 있고 항목은 없었다). ② 그 주석을 믿고 26-08-04 에
  //   '계약'을 실제로 붙였다가 §Phase 3 결정에 어긋나 되돌렸다.
  //   → 사이드바 항목의 진실은 **문구가 아니라 Sidebar.test.tsx** 다.
  'nav.item.deals': '영업 파이프라인',
  'nav.item.contracts': '계약',
  'nav.item.stores': '매장',
  'nav.item.robots': '로봇',
  'nav.item.reports': '리포트 인박스',
  'nav.item.service_orders': '서비스 오더',
  'nav.item.triage_queue': '분류 큐',
  'nav.item.infrastructure': '캘린더 · 인프라 발주',
  'nav.item.fleet_tracker': '추적 · 분석',
  'nav.item.privacy_requests': 'DSAR 인박스',
  'nav.item.audit_logs': '감사 로그',
  'nav.item.users': '사용자',
  'nav.item.incomplete_records': '미입력 인박스',
  'nav.item.option_groups': '옵션 그룹',
  'nav.item.retire_candidates': '회수 검토',
  'nav.item.self_check_logs': '셀프 체크 로그',
  'nav.item.production_plan': '제조 계획',
  'nav.item.assignments': '로봇 배정',
  'nav.item.install_calendar': '설치 일정',

  // ── TopBar / User panel ────────────────────────────────────────────────────
  'topbar.logout': '로그아웃',

  'role.admin': '관리자',
  'role.manager': '매니저',
  'role.sales_manager': '사업팀 매니저',
  'role.mfg_manager': '제조팀 매니저',
  'role.field_manager': '필드팀 매니저',
  'role.viewer': '뷰어',

  'owner.honeycomb_robotics': '허니컴로보틱스',
  'owner.beyond_honeycomb': '비욘드허니컴',

  // ── Locale switcher ────────────────────────────────────────────────────────
  'locale.ko': '한국어',
  'locale.ja': '日本語',
  'locale.zh': '简体中文',

  // ── Common / shared ────────────────────────────────────────────────────────
  'common.loading': '불러오는 중…',
  'common.no_results': '결과가 없습니다',
  'common.error_load': '데이터를 불러오지 못했습니다',
  'common.cancel': '취소',
  'common.confirm': '확인',
  'common.save': '저장',
  'common.delete': '삭제',
  'common.edit': '편집',
  'common.close': '닫기',
  'common.submit': '제출',
  'common.processing': '처리 중…',
  'common.search_placeholder': '검색…',
  'common.all': '전체',
  'common.none': '없음',
  'common.yes': '예',
  'common.no': '아니오',
  'common.items_count': '{count, number}건',
  'common.page_of': '{page} / {total}',
  'common.prev': '이전',
  'common.next': '다음',
  'common.csv_export': 'CSV 내보내기',
  'common.exporting': '내보내는 중…',
  'common.assign_me': '나에게 배정',
  'common.assigned_to_me': '나에게 배정',
  'common.open_only': '미완료만',
  'common.unresolved_only': '미해결만',
  'common.update_failed': '업데이트하지 못했습니다',
  'common.danger_irreversible': '이 작업은 되돌릴 수 없습니다.',

  // ── Owner entity labels (page-level) ──────────────────────────────────────
  'entity.honeycomb_robotics': '허니컴로보틱스',
  'entity.beyond_honeycomb': '비욘드허니컴',

  // ── Service Orders ─────────────────────────────────────────────────────────
  'so.page_title': '서비스 오더 인박스',
  'so.triage_title': '서비스 오더 분류 큐',
  'so.new_title': '서비스 오더 신규 등록',

  'so.empty': '처리 중인 서비스 오더가 없습니다',
  'so.empty_sub': '새 접수가 생기면 여기에 표시됩니다.',

  'so.col.status': '상태',
  'so.col.category': '분류',
  'so.col.robot': '로봇',
  'so.col.customer': '고객사',
  'so.col.assignee': '담당자',
  'so.col.created': '접수 시각',
  'so.col.sla': 'SLA',

  'so.status.open': '신규',
  'so.status.triaged': '분류완료',
  'so.status.assigned': '배정',
  'so.status.in_progress': '진행중',
  'so.status.blocked': '대기',
  'so.status.resolved': '해결',
  'so.status.verified': '검증완료',
  'so.status.closed': '종료',
  'so.status.cancelled': '취소',

  'so.category.preventive': '예방 점검',
  'so.category.reactive': '장애 대응',
  'so.category.install': '설치',
  'so.category.removal': '철거',
  'so.category.parts_swap': '부품 교체',

  'so.action.triage': '분류',
  'so.action.assign_me': '나에게 배정 & 검토',
  'so.action.transition': '상태 변경',
  'so.action.cancel': '취소',
  'so.action.restore': '복구',
  'so.action.reassign_customer': '고객 재배정',
  'so.action.resolve': '해결',

  'so.select_prompt': '서비스 오더를 선택하세요.',
  'so.cancel_reason_required': '취소 사유 (필수)',
  'so.cancel_confirm_title': '서비스 오더 취소',
  'so.restore_confirm_title': '서비스 오더 복구',
  'so.restore_confirm_msg': '이 서비스 오더를 복구하시겠습니까?',

  // ── Reports ────────────────────────────────────────────────────────────────
  'reports.page_title': '리포트 인박스',
  'reports.empty': '처리할 리포트가 없습니다',
  'reports.empty_sub': '고객이 QR을 스캔해 리포트를 보내면 여기에 표시됩니다.',
  'reports.select_prompt': '리포트를 선택하세요.',

  'reports.col.urgency': '긴급',
  'reports.col.id': 'ID',
  'reports.col.status': '상태',
  'reports.col.robot': '로봇',
  'reports.col.category': '분류',
  'reports.col.preview': '미리보기',
  'reports.col.submitted_at': '제출 시각',

  'reports.status.new': '신규',
  'reports.status.triaged': '분류완료',
  'reports.status.assigned': '배정',
  'reports.status.in_progress': '진행중',
  'reports.status.resolved': '해결',
  'reports.status.dismissed': '반려',
  'reports.status.duplicate': '중복',

  'reports.severity.urgent': '긴급',
  'reports.severity.normal': '일반',
  'reports.urgency_filter.urgent_only': '긴급만',
  'reports.urgency_filter.normal_only': '일반만',

  'reports.category.hardware_failure': '하드웨어 고장',
  'reports.category.cooking_quality': '조리 품질',
  'reports.category.cleaning_hygiene': '청소 · 위생',
  'reports.category.dispensing': '토출 · 공급',
  'reports.category.connectivity': '통신',
  'reports.category.ui_ux': 'UI',
  'reports.category.other': '기타',

  'reports.detail.category': '분류',
  'reports.detail.urgency': '긴급도',
  'reports.detail.robot': '로봇',
  'reports.detail.store': '매장',
  'reports.detail.contact': '연락처',
  'reports.detail.description': '상세 내용',
  'reports.detail.current_status': '현재 상태',

  'reports.action.assign_me': '나에게 배정',
  'reports.action.in_progress': '진행중',
  'reports.action.resolve': '해결',
  'reports.action.dismiss': '반려',
  'reports.action.resolve_label': '해결',
  'reports.action.dismiss_label': '반려',

  'reports.modal.resolve_title': '리포트 해결',
  'reports.modal.resolve_note_label': '해결 메모',
  'reports.modal.resolve_note_required': '해결 메모 (필수)',
  'reports.modal.dismiss_title': '리포트 반려',
  'reports.modal.dismiss_reason_label': '반려 사유',
  'reports.modal.dismiss_reason_required': '반려 사유 (필수)',

  // ── Privacy Requests (DSAR) ────────────────────────────────────────────────
  'dsar.page_title': '개인정보 요청 (DSAR) 인박스',
  'dsar.empty': '처리할 DSAR 요청이 없습니다',
  'dsar.empty_sub': '고객이 개인정보 요청 페이지에서 요청을 보내면 여기에 표시됩니다.',
  'dsar.select_prompt': '요청을 선택하세요.',

  'dsar.status.received': '접수됨',
  'dsar.status.in_review': '검토 중',
  'dsar.status.fulfilled': '처리 완료',
  'dsar.status.rejected': '반려',

  'dsar.type.access': '열람',
  'dsar.type.correction': '정정',
  'dsar.type.deletion': '삭제',
  'dsar.type.restriction': '처리 정지',
  'dsar.type.other': '기타',

  'dsar.col.sla': 'SLA',
  'dsar.col.id': '접수 번호',
  'dsar.col.status': '상태',
  'dsar.col.type': '유형',
  'dsar.col.locale': '언어',
  'dsar.col.subject': '신청인',
  'dsar.col.preview': '미리보기',
  'dsar.col.submitted_at': '제출 시각',

  'dsar.locale.ko': '한국어',
  'dsar.locale.en': 'English',
  'dsar.locale.zh': '简体中文',

  'dsar.detail.current_status': '현재 상태',
  'dsar.detail.id': '접수 번호',
  'dsar.detail.type': '유형',
  'dsar.detail.locale': '언어',
  'dsar.detail.subject': '신청인',
  'dsar.detail.contact': '연락처',
  'dsar.detail.related_report': '관련 리포트',
  'dsar.detail.assignee': '담당',
  'dsar.detail.fulfilled_at': '완료 시각',
  'dsar.detail.description': '요청 내용',
  'dsar.detail.review_note': '검토 메모',
  'dsar.detail.rejected_reason': '반려 사유',

  'dsar.action.assign_review': '나에게 배정 & 검토',
  'dsar.action.fulfill': '처리 완료',
  'dsar.action.reject': '반려',
  'dsar.modal.fulfill_title': 'DSAR 처리 완료',
  'dsar.modal.fulfill_note_label': '검토 메모 (선택)',
  'dsar.modal.reject_title': 'DSAR 반려',
  'dsar.modal.reject_reason_label': '반려 사유 (필수)',

  'dsar.sla.badge': '30d↑',
  'dsar.sla.exceeded': 'SLA 초과',

  // ── Audit Logs ─────────────────────────────────────────────────────────────
  'audit.page_title': '감사 로그',
  'audit.empty': '조건에 맞는 감사 로그가 없습니다',
  'audit.empty_sub': '필터를 바꾸거나 "전체"를 눌러 다시 찾아 보세요.',
  'audit.select_prompt': '줄을 누르면 자세한 내용이 보입니다.',

  'audit.filter.action': '액션',
  'audit.filter.action_placeholder': '예: robot.create, auth.*',
  'audit.filter.resource_type': '리소스 타입',
  'audit.filter.resource_type_placeholder': '예: Robot, CustomerReport',
  'audit.filter.resource_id': '리소스 ID',
  'audit.filter.resource_id_placeholder': 'cuid / displayId',
  'audit.filter.entity': '법인',
  'audit.filter.outcome': '결과',
  'audit.filter.from_date': '시작일',
  'audit.filter.to_date': '종료일',

  'audit.preset.all': '전체',
  'audit.preset.auth': '인증',
  'audit.preset.robot': '로봇',
  'audit.preset.qr': 'QR',
  'audit.preset.deployment': '배치',
  'audit.preset.report': '리포트',
  'audit.preset.dsar': 'DSAR',
  'audit.preset.user': '사용자',

  'audit.col.time': '시각',
  'audit.col.action': '액션',
  'audit.col.resource': '리소스',
  'audit.col.actor': '행위자',
  'audit.col.entity': '법인',
  'audit.col.outcome': '결과',

  'audit.outcome.success': '성공',
  'audit.outcome.failure': '실패',
  'audit.outcome.failure_badge': '실패',

  'audit.detail.id': 'ID',
  'audit.detail.time': '시각',
  'audit.detail.action': '액션',
  'audit.detail.resource': '리소스',
  'audit.detail.resource_id': '리소스 ID',
  'audit.detail.actor': '행위자',
  'audit.detail.entity': '법인',
  'audit.detail.outcome': '결과',
  'audit.detail.ip': 'IP',
  'audit.detail.request_id': '요청 ID',
  'audit.detail.error': '오류 메시지',
  'audit.detail.diff': '바뀐 내용',
  'audit.detail.user_agent': 'User-Agent',
  'audit.detail.system_anonymous': '시스템 또는 익명',
} as const;

export type MessageKey = keyof typeof ko;
export default ko;
